import React from 'react';

import { Button } from '@codes/ui-kit/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export interface AgentCatalogPaginationProps {
    currentPage: number;
    totalPages: number;
    paginationRange: (number | string)[];
    onPageChange: (page: number) => void;
}

export const AgentCatalogPagination: React.FC<AgentCatalogPaginationProps> = ({
    currentPage,
    totalPages,
    paginationRange,
    onPageChange,
}) => {
    if (totalPages <= 1) {
        return null;
    }
    return (
        <div className="flex items-center justify-center space-x-2 p-6">
            <Button
                variant="outline"
                size="sm"
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 0}
                className="h-8 w-8 p-0"
            >
                <ChevronLeft className="h-4 w-4" />
            </Button>
            {paginationRange.map((pageNumber, idx) => (
                <Button
                    key={idx}
                    variant={pageNumber === currentPage ? 'default' : 'outline'}
                    size="sm"
                    onClick={() => typeof pageNumber === 'number' && onPageChange(pageNumber)}
                    disabled={typeof pageNumber !== 'number'}
                    className="h-8 min-w-8 px-2"
                >
                    {typeof pageNumber === 'number' ? pageNumber + 1 : '...'}
                </Button>
            ))}
            <Button
                variant="outline"
                size="sm"
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage >= totalPages - 1}
                className="h-8 w-8 p-0"
            >
                <ChevronRight className="h-4 w-4" />
            </Button>
        </div>
    );
};
